module.exports = __webpack_public_path__ + "img/ysgj_048@2x.139e2a7d.png";